import { render } from "./TheFormStep.vue?vue&type=template&id=4dde012e&scoped=true&ts=true"
import script from "./TheFormStep.vue?vue&type=script&lang=ts"
export * from "./TheFormStep.vue?vue&type=script&lang=ts"

import "./TheFormStep.vue?vue&type=style&index=0&id=4dde012e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dde012e"]])

export default __exports__